// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2-T0W","buttons":"RemoveExpirationActionButtons_buttons__3FkSB"};